import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { MatchCardData, MatchCardSubscriptionData } from '../types';

export const isValidMatchCard = (obj: MatchCardData): boolean =>
  Boolean(obj?.data?.getMatchCardWidget && !isEmptyObject(obj.data.getMatchCardWidget));

export const isValidMatchCardSubscription = (obj: MatchCardSubscriptionData): boolean =>
  Boolean(obj?.data?.onUpdateMatchCardById && !isEmptyObject(obj.data.onUpdateMatchCardById));